import apiComunicacaoOficial from '../infra/apiComunicacaoOficial'

const OficioService = {
    MontaMenu: async () => {
        return await apiComunicacaoOficial.get('/api/v1/Oficio/montamenu')
    },
    SubMenu: async (pagina, qtdePagina, chaveMenu, idOficio) => {
        if (idOficio === null || idOficio === undefined) {
            return await apiComunicacaoOficial.get(`/api/v1/Oficio/submenu/${pagina}/${qtdePagina}/${chaveMenu}`);
        }

        return await apiComunicacaoOficial({
            method: 'get',
            url: `/api/v1/Oficio/submenu/${pagina}/${qtdePagina}/${chaveMenu}`,
            headers: {
                'idOficio': idOficio
            },
        })
    },
    Consulta: async (idOficio, carregaConteudoDocumento) => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/consulta/${idOficio}/${carregaConteudoDocumento}`)
    },
    Salvar: async (oficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/salva`, oficio)
    },
    Download: async (idOficio) => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/download/base64/${idOficio}`)
    },
    Assinar: async (oficiosTramite) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/tramite/assinar`, oficiosTramite)
    },
    AssinaPresidente: async (oficios) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/assinapresidente`, oficios)
    },
    ConsultaTramite: async (oficios) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/consulta/tramite`, oficios)
    },
    EnviarTramite: async (tramite) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/tramite/enviar`, tramite)
    },
    CancelaAssinatura: async (oficios) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/tramite/desassinar`, oficios)
    },
    EnviaAoInteressado: async (idOficio, codigoRastreio) => {

        let header = codigoRastreio != null ? { 'codigoRastreio': codigoRastreio } : {}

        return await apiComunicacaoOficial({
            method: 'post',
            url: `/api/v1/Oficio/reciboentrega/enviar/${idOficio}`,
            headers: header,
        })
    },
    CancelaEnvioAoInteressado: async (idOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/cancela/${idOficio}`)
    },
    CancelaEnvioAoInteressadoLista: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/cancelaemlista`, idsOficio)
    },
    SolicitaEnvioPeloSetorDePostagem: async (idOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/solicitaenviosetorpostagem/${idOficio}`)
    },
    SolicitaEnvioPeloSetorDePostagemLista: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/solicitaenviosetorpostagemlista`, idsOficio)
    },
    CancelaSolicitacaoEnvioPeloSetorDePostagem: async (idOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/removesolicitacaoenviosetorpostagem/${idOficio}`)
    },
    CancelaSolicitacaoEnvioPeloSetorDePostagemLista: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/removesolicitacaoenviosetorpostagemlista`, idsOficio)
    },
    ConsultaReciboEntrega: async (idOficio) => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/reciboentrega/consulta/${idOficio}`)
    },
    DownloadReciboEntrega: async (idOficio) => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/reciboentrega/downloadbase64/${idOficio}`)
    },
    SalvaReciboEntrega: async (idOficio, recibo, arquivo, setProgressoUploadArquivo) => {
        return await apiComunicacaoOficial({
            method: 'post',
            url: `/api/v1/Oficio/reciboentrega/salva/${idOficio}`,
            headers: {
                'interessadoRecebeu': recibo.interessadoRecebeu,
                'dataEnvio': recibo.dataEnvio,
                'dataRecebimento': recibo.dataRecebimento,
                'motivoNaoRecebimento': recibo.motivoNaoRecebimento,
                'codigoPostagem': recibo.codigoPostagem,
                'descritorRegiaoEntregaId': recibo.descritorRegiaoEntregaId
            },
            data: arquivo,
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgressoUploadArquivo(prevState => ({
                    ...prevState,
                    porcentagem: percentCompleted
                }))
            }
        })
    },
    Fixar: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/fixar`, idsOficio)

    },
    EnviarLixeira: async (idOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/lixeira/envia/${idOficio}`)
    },
    EnviarLixeiraEmLista: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/lixeira/envialista`, idsOficio)
    },
    ReativarOficioDaLixeira: async (idOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/lixeira/reativa/${idOficio}`)
    },
    ExcluiDefinitivamente: async (idOficio) => {
        return await apiComunicacaoOficial.delete(`/api/v1/Oficio/lixeira/excluirdefinitivamente/${idOficio}`)
    },
    DownloadCertidao: async (idOficio) => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/certidao/download/base64/${idOficio}`)
    },
    RemoveCertidao: async (oficio) => {
        return await apiComunicacaoOficial({
            method: 'delete',
            url: `/api/v1/Oficio/certidao/remove`,
            headers: {
                'idsOficios': oficio,
            },
        })
    },
    AssinarCertidaoArt166: async (oficio) => {
        return await apiComunicacaoOficial.post('/api/v1/Oficio/certidao/assinar', oficio)
    },
    CancelaAssinaturaCertidaoArt166: async (oficio) => {
        return await apiComunicacaoOficial.post('/api/v1/Oficio/certidao/desassinar', oficio)
    },
    RegistraBugReciboEntrega: async (idOficio, comErro) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/reciboentrega/bug/${idOficio}/${comErro}`)
    },
    CriaCertidao: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/certidao/cria`, idsOficio)
    },
    RealizaJuntada: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/juntada/realiza`, idsOficio)
    },
    CancelaJuntadaOficio: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/juntada/cancela`, idsOficio);
    },
    EnviaCertidaoParaAssinatura: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/certidao/enviaparaassinatura`, idsOficio);
    },
    EnviaCertidaoParaEdicao: async (idsOficio) => {
        return await apiComunicacaoOficial.post(`/api/v1/Oficio/certidao/enviaparaedicao`, idsOficio);
    },
    ConsultaDadosPesquisaAvancada: async () => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/pesquisa/montadados`);
    },
    ConsultaOficiosDoUsuarioAnalista: async () => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/consulta/notificacao`);
    },
    SubMenuComFiltroAvancado: async (pagina, qtdePagina, chaveMenu, parametroConsultaRapida, parametrosConsultaAvancada) => {
        return await apiComunicacaoOficial({
            method: 'post',
            url: `/api/v1/Oficio/submenu-v2/${pagina}/${qtdePagina}/${chaveMenu}?parametroConsultaRapida=${parametroConsultaRapida}`,
            data: JSON.stringify(parametrosConsultaAvancada),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    },
    ConsultaComFiltros: async (pagina, qtdePorPagina, parametrosConsultaAvancada) => {
        return await apiComunicacaoOficial({
            method: 'post',
            url: `/api/v1/Oficio/consulta/filtros/${pagina}/${qtdePorPagina}`,
            data: JSON.stringify(parametrosConsultaAvancada),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
    },
    ConsultaAnalistasSetor: async () => {
        return await apiComunicacaoOficial.get(`/api/v1/Oficio/consulta/analistassetor`)
    },
    RemoveReciboEntrega: async (oficio) => {
        return await apiComunicacaoOficial({
            method: 'delete',
            url: `/api/v1/Oficio/reciboentrega/remove`,
            headers: {
                'idsOficios': oficio,
            },
        })
    },    
    DeletaBoletos: async (oficio) => {
        return await apiComunicacaoOficial({
            method: 'delete',
            url: `/api/v1/Oficio/boletos/${oficio}/1/1`
        })
    },
    RecriaBoletos: async (oficio) => {
        return await apiComunicacaoOficial({
            method: 'post',
            url: `/api/v1/Oficio/boletos/recria/${oficio}/1/1`
        })
    },
}

export default OficioService    